import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportClientError } from "../lib/error-reporter";

// Последний рубеж между сбоем в рендере и белым экраном.
//
// Без него любая ошибка в дереве компонентов размонтирует всё приложение и
// оставляет пустую страницу: человек не понимает, что произошло, а мы об этом
// вообще не узнаём. Здесь и то, и другое: отчёт уходит в мониторинг, а на
// экране остаётся объяснение и способ продолжить.
type Props = { children: ReactNode; fallback: (retry: () => void) => ReactNode };
type State = { hasError: boolean };

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Стек компонентов говорит, где именно сломалось, — по одному стеку
    // минифицированного бандла это не всегда видно.
    reportClientError(
      new Error(`${error.message}${info.componentStack ? `\n${info.componentStack.slice(0, 2000)}` : ""}`),
      "render",
    );
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return this.props.fallback(() => this.setState({ hasError: false }));
  }
}
